import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings } from '@styles/index';
import Breadcrumbs from 'aquilla/core/molecules/Breadcrumbs';
import ArrowBack from '@icon/ArrowBack';
import useWindowSize from '@hooks/useWindowSize';
import Link from '../Link/Link';
import IconButton from '../IconButton/IconButton';

const BreadCrumb = styled.div`
  border: 1px solid var(--color-divider);
`;

const StyledCrumbs = styled(Breadcrumbs)`
  height: ${Spacings.SPACING_4B};
  cursor: pointer;
  border-radius: ${Spacings.SPACING_2B};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButton = styled(IconButton)`
  margin-right: ${Spacings.SPACING_3B};
  box-shadow: none;
  background-color: var(--color-base-1);
`;

const NewBreadCrumbs = ({ tags, className, useBackClick }) => {
  const { isMobile } = useWindowSize();
  const tagsLength = tags?.length || 0;
  const lastLink =
    tagsLength > 0 && !useBackClick ? tags?.[tagsLength - 1] : null;
  return (
    <Wrapper className={className}>
      {lastLink && isMobile && (
        <Link href={lastLink.href} as={lastLink.as}>
          <BreadCrumb as={BackButton} bgColor="var(--color-base-0)" hovDisabled>
            <ArrowBack
              size={Spacings.SPACING_4B}
              color="var(--color-text-primary)"
            />
          </BreadCrumb>
        </Link>
      )}

      <StyledCrumbs
        fragments={tags?.map((tag) => ({
          title: tag.title,
          url: tag.as
        }))}
      />
    </Wrapper>
  );
};

export default NewBreadCrumbs;

NewBreadCrumbs.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      as: PropTypes.string,
      href: PropTypes.string.isRequired
    })
  ),
  className: PropTypes.string,
  useBackClick: PropTypes.bool
};

NewBreadCrumbs.defaultProps = {
  className: '',
  tags: [],
  useBackClick: false
};
